export const SET_BUILDER_CONTENTS = 'SET_BUILDER_CONTENTS';
export const RESET_BUILDER_CONTENTS = 'RESET_BUILDER_CONTENTS';
